export const HYBRIS_UNIT_NAME = {
  EA: 'EA',
  PKG: 'PKG',
  SET: 'SET'
};
